import React from 'react';
import { useHistory } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import './ContactCTA.css';

const ContactCTA = () => {
    const history = useHistory();
    const pageConfig = {
        title: "Need Expert Hydraulic Solutions?",
        subtitle: "Talk to our Ireland-based team for tailored advice on products and services. We respond quickly and help you choose the right solution.",
        ctaText: "Enquire Now"
    };

    const handleContactClick = () => {
        history.push('/contact-us#contact-form-section');
        
        // Scroll to contact form after navigation
        setTimeout(() => {
            const element = document.getElementById('contact-form-section');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    const handlePhoneClick = () => {
        window.location.href = 'tel:+35318001111';
    };

    const handleEmailClick = () => {
        window.location.href = 'mailto:info@hansa-flex.ie';
    };

    return (
        <div className="contact-cta">
            <div className="contact-cta-container">
                <div className="contact-cta-content">
                    <div className="contact-cta-text">
                        <h2 className="contact-cta-title">{pageConfig.title}</h2>
                        <p className="contact-cta-subtitle">{pageConfig.subtitle}</p>
                    </div>
                    
                    <div className="contact-cta-actions">
                        <button 
                            className="contact-cta-button primary"
                            onClick={handleContactClick}
                        >
                            {pageConfig.ctaText}
                            <FaArrowRight className="contact-cta-icon" />
                        </button>
                        
                        <div className="contact-cta-secondary">
                            <button 
                                className="contact-cta-button secondary"
                                onClick={handlePhoneClick}
                            >
                                <FaPhone className="contact-cta-icon" />
                                Call Us
                            </button>
                            
                            <button 
                                className="contact-cta-button secondary"
                                onClick={handleEmailClick}
                            >
                                <FaEnvelope className="contact-cta-icon" />
                                Email Us
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactCTA; 